import React from 'react';
import { useParams } from 'react-router-dom';
import { PageTemplateSpinner } from '@sierralabs/core-ui';
import FormDataEditor from '../data/FormDataEditor';
import { useFindLatestFormTemplateVersion } from '../FormTemplate.hooks';
import { Alert } from '@material-ui/lab';
import styled from 'styled-components';
const StyledAlert = styled(Alert) `
  margin: 0 -30px;
  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0 -10px;
  }
`;
const FormDataTab = () => {
    const { formTemplateId = 0 } = useParams();
    const { formTemplateVersion, isLoading } = useFindLatestFormTemplateVersion(+formTemplateId, true);
    return isLoading ? (React.createElement(PageTemplateSpinner, null)) : formTemplateVersion ? (React.createElement(FormDataEditor, { formTemplateVersion: formTemplateVersion })) : (React.createElement(StyledAlert, { severity: 'warning' }, "No published form template. Please publish the form template and schema to manage form data."));
};
export default FormDataTab;
//# sourceMappingURL=FormDataTab.js.map